module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.infos.channels.length > 0) ? _c('div', {
    staticClass: "infos"
  }, [(_vm.infos.channels.length) ? _c('div', {
    attrs: {
      "id": "channels"
    }
  }, [_vm._v("\n            Related：\n            "), _vm._l((_vm.infos.channels), function(channels) {
    return [_c('a', {
      key: channels.tag,
      attrs: {
        "href": _vm.isInApp ? channels.href : 'javascript:void(0);'
      },
      domProps: {
        "innerHTML": _vm._s(channels.tag)
      }
    })]
  })], 2) : _vm._e()]) : _c('div', {
    staticStyle: {
      "height": "10px"
    }
  }), _vm._v(" "), (_vm.infos.column.id) ? _c('div', {
    staticClass: "column-ad"
  }, [_c('a', {
    attrs: {
      "href": _vm.isInApp ? _vm.infos.column.href : 'javascript:void(0);'
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.infos.column.show_footer_image)
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f4e90c9","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/infos.vue
// module id = 747
// module chunks = 1